import React from "react";

const Button = ({ children, variant, onClick, isDisabled, style }) => {
  return (
    <button
      type="button"
      disabled={isDisabled}
      className={`btn ${variant}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;
